import { Button, Card, CardContent, CardHeader, CardTitle } from '@features/ui';
import React from 'react';
import { TPackages } from '@src/types';

type Props = {
  packages: TPackages[];
  onSelectAccount: (account: TPackages) => void;
  selectedAccount?: TPackages;
};

export const SelectAccountCard: React.FC<Props> = ({
  packages,
  onSelectAccount,
  selectedAccount,
}) => {
  return (
    <Card className="bg-card py-5 lg:py-10 px-1 w-full lg:w-1/3">
      <CardHeader className="px-0 border-b pb-4 lg:pb-6">
        <CardTitle className="text-[25px] font-medium text-center">
          Choose Size
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4 px-0 pt-7">
        <div className="flex flex-col gap-2">
          {packages.map((item) => (
            <Button
              key={item.id}
              className="h-20 lg:h-[137px] text-3xl lg:text-[46px] font-bold"
              size={'lg'}
              variant={item.id === selectedAccount?.id ? 'gradient' : 'ghost'}
              onClick={() => onSelectAccount(item)}
            >
              {item.display_name_web}
            </Button>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
